import {
  SET_CART_DETAIL,
  SET_CATEGORIES,
  SET_SUB_CATEGORIES,
  SET_PRODUCTS,
  SET_PRODUCT_DETAIL,
  SET_STORE_DETAIL,
  SET_SHIPPING_CHARGES,
  SET_ORDER_DETAIL,
  SET_PAYMENT_INFO,
  SET_RECENT_ORDER,
  SET_ZONEWISE_DELIVERYCHARGES,
  SET_SEARCH_RESULTS,
  SET_BIRDBUCK_COUPON,
  SET_TAXES,
  SET_STORE_LOCATIONS,
  SET_USER_SHIPPING_ZONE_INFO,
  SET_SUBSCRIPTIONS,
  SET_SUBSCRIPTIONS_DETAIL,
  SET_AVAILABLE_SUBSCRIPTIONS_INTERVAL,
  SET_SUBSCRIBABLE_PRODUCTS,
  SET_SUBSCRIPTION_CONFIG,
  SET_DISCOUNT_COUPON,
  SET_PROMO_IMAGE,
  SET_STORE_FEATURE,
  SET_BIRDBUCKS_BY_USER,
  SET_STORE_DISCOUNT_MAP,
  SET_REFERRAL_PRODUCTS,
  SET_ORDER_POINTS,
  SET_GIFT_CARDS,
  SET_ERPLY_BIRDBUCKS_BY_USER

} from './action-types';

const INITIAL_STATE = {
  /*eslint-disable*/
  cartDetail: {
    cartItems: []
  },
  categories: [],
  // categories: [{"category":{"id":1,"name":"Bird Food","code":null,"department":{"id":1,"name":"Products","code":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/category-images/Image.png","description":null},"subCategoryList":[{"id":1,"name":"Food Blends1","description":"This is food blends produc 1t for all season birds","category":{"id":1,"name":"Bird Food","code":null,"department":{"id":1,"name":"Products","code":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/category-images/Image.png","description":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/subcategory-images/Image.png"},{"id":2,"name":"Food Blends2","description":"This is food blends product 2for all season birds","category":{"id":1,"name":"Bird Food","code":null,"department":{"id":1,"name":"Products","code":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/category-images/Image.png","description":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/subcategory-images/Image.png"}]},{"category":{"id":2,"name":"Bird Feeders","code":null,"department":{"id":1,"name":"Products","code":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/category-images/Image.png","description":null},"subCategoryList":[{"id":3,"name":"Bird Fooders","description":"This is the bird fooders sub category","category":{"id":2,"name":"Bird Feeders","code":null,"department":{"id":1,"name":"Products","code":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/category-images/Image.png","description":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/subcategory-images/Image.png"}]},{"category":{"id":3,"name":"Hardware","code":null,"department":{"id":1,"name":"Products","code":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/category-images/Image.png","description":null},"subCategoryList":[]}],
  subCategories: [],
  products: [],
  productDetail: {},
  storeDetail: {},
  shippingCharges: [],
  orderDetail: {},
  paymentInfo: [],
  recentOrder: [],
  zoneDeliveryCharges: [],
  searchResults: [],
  coupon: {},
  taxes: {},
  storeLocations: [],
  userShippingZone: {},
  subscriptions: [],
  subscriptionsDetail: {},
  availableSubscriptionsInterval: [],
  subscribableProducts: [],
  subscriptionConfig: {},
  discountCoupon: {},
  promoImage: {},
  storeFeatures: {},
  birdBucksList: {},
  storeDiscountMap: {},
  referralProducts: [],
  orderPoints: {},
  giftCards: []

  /*eslint-enable*/
};

export default function orderReducer(state = INITIAL_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case SET_CART_DETAIL:
      return Object.assign({}, state, {
        cartDetail: action.data
      });
    case SET_SUBSCRIPTIONS:
      return Object.assign({}, state, {
        subscriptions: action.data
      });
    case SET_AVAILABLE_SUBSCRIPTIONS_INTERVAL:
      return Object.assign({}, state, {
        availableSubscriptionsInterval: action.data
      });
    case SET_SUBSCRIPTIONS_DETAIL:
      return Object.assign({}, state, {
        subscriptionsDetail: action.data
      });
    case SET_SUBSCRIPTION_CONFIG:
      return Object.assign({}, state, {
        subscriptionConfig: action.data
      });
    case SET_CATEGORIES:
      return Object.assign({}, state, {
        categories: action.data.categories
      });
    case SET_SUB_CATEGORIES:
      return Object.assign({}, state, {
        subCategories: action.data.subCategories
      });
    case SET_PRODUCTS:
      return Object.assign({}, state, {
        products: action.data
      });
    case SET_PRODUCT_DETAIL:
      return Object.assign({}, state, {
        productDetail: action.data
      });
    case SET_STORE_DETAIL:
      return Object.assign({}, state, {
        storeDetail: action.data
      });
    case SET_SHIPPING_CHARGES:
      return Object.assign({}, state, {
        shippingCharges: action.data
      });
    case SET_ORDER_DETAIL:
      return Object.assign({}, state, {
        orderDetail: action.data
      });
    case SET_PAYMENT_INFO:
      return Object.assign({}, state, {
        paymentInfo: action.data
      });
    case SET_RECENT_ORDER:
      return Object.assign({}, state, {
        recentOrder: action.data
      });
    case SET_ZONEWISE_DELIVERYCHARGES:
      return Object.assign({}, state, {
        zoneDeliveryCharges: action.data
      });
    case SET_SEARCH_RESULTS:
      return Object.assign({}, state, {
        searchResults: action.data
      });
    case SET_BIRDBUCK_COUPON:
      return Object.assign({}, state, {
        coupon: action.data
      });
    case SET_TAXES:
      return Object.assign({}, state, {
        taxes: action.data
      });
    case SET_STORE_LOCATIONS:
      return Object.assign({}, state, {
        storeLocations: action.data
      });
    case SET_USER_SHIPPING_ZONE_INFO:
      return Object.assign({}, state, {
        userShippingZone: action.data
      });
    case SET_SUBSCRIBABLE_PRODUCTS:
      return Object.assign({}, state, {
        subscribableProducts: action.data
      });
    case SET_DISCOUNT_COUPON:
      return Object.assign({}, state, {
        discountCoupon: action.data
      });
    case SET_PROMO_IMAGE:
      return Object.assign({}, state, {
        promoImage: action.data
      });
    case SET_STORE_FEATURE:
      return Object.assign({}, state, {
        storeFeatures: action.data
      });
    case SET_BIRDBUCKS_BY_USER:
      return Object.assign({}, state, {
        birdBucksList: action.data
      });
    case SET_STORE_DISCOUNT_MAP:
      return Object.assign({}, state, {
        storeDiscountMap: action.data
      });
    case SET_REFERRAL_PRODUCTS:
      return Object.assign({}, state, {
        referralProducts: action.data
      });
    case SET_ORDER_POINTS:
      return Object.assign({}, state, {
        orderPoints: action.data
      });
    case SET_GIFT_CARDS:
      return Object.assign({}, state, {
        giftCards: action.data
      });
    case SET_ERPLY_BIRDBUCKS_BY_USER:
      return Object.assign({}, state, {
        erplyBirdBucksList: action.data
      });
      
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/app/order/reducer.js